export class PasswordStepConfigModel {
  min: number;
  max: number;
  color: string;
  hint: string;
  shortHint: string;
}
